import type { IntentResult, InterleavedIntentResult, Product } from '@shared/types/types.ts';
import { isRankedIntent, isSponsoredIntent, isSponsoredProduct } from '@shared/types/types.ts';
import { interleave } from '@tilelist/domain/composition/SponsoredProductsInterleaving.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 */
const DEFAULT_PRODUCT_TYPE = 'AS' as const;

/**
 *
 *
 */
export function interleaveRankedAndSponsoredProducts(intents: IntentResult[]): ProductItem[] {
    const rankedIntent = intents.find(isRankedIntent);
    const rankedProducts = rankedIntent?.products || [];

    if (rankedProducts.length === 0) {
        return [];
    }

    const sponsoredIntent = intents.find(isSponsoredIntent);
    const sponsoredProducts = sponsoredIntent?.products || [];
    const startingOffset = rankedIntent?.meta?.offset || 0;

    const interleavedProducts = interleave(sponsoredProducts, rankedProducts);

    return enrichInterleavedProductsWithPositioning(interleavedProducts, startingOffset);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function enrichInterleavedProductsWithPositioning(
    interleavedProducts: Product[],
    startingOffset: number,
): ProductItem[] {
    let rankedSourceIndex = 0;
    let sponsoredSourceIndex = 0;

    return interleavedProducts.map((product, interleavedIndex) => {
        const isSponsored = isSponsoredProduct(product);
        const originPosition = isSponsored ? sponsoredSourceIndex++ : startingOffset + rankedSourceIndex++;

        return toProductItem({
            product,
            interleavedIndex,
            startingOffset,
            originPosition,
        });
    });
}

/**
 *
 */
export function toProductItem({
    product,
    interleavedIndex,
    startingOffset,
    originPosition,
}: {
    product: Product;
    interleavedIndex: number;
    startingOffset: number;
    originPosition: number;
}): ProductItem {
    return {
        product,
        variations: [],
        type: DEFAULT_PRODUCT_TYPE,
        localListPosition: interleavedIndex + 1,
        actualListPosition: startingOffset + interleavedIndex + 1,
        originPosition,
    };
}

/**
 *
 *
 *
 *
 *
 */
export function enrichSearchProvidedInterleavedProducts(interleavedIntent: InterleavedIntentResult): ProductItem[] {
    const offset = interleavedIntent.meta?.offset ?? 0;
    let organicIndex = 0;
    let sponsoredIndex = 0;

    return interleavedIntent.products.map((product, index) => {
        const isSponsored = isSponsoredProduct(product);
        const originPosition = isSponsored ? sponsoredIndex++ : organicIndex++;

        return {
            product,
            variations: [],
            type: DEFAULT_PRODUCT_TYPE,
            localListPosition: index + 1,
            actualListPosition: offset + index + 1,
            originPosition,
        };
    });
}
